import {Component} from '@angular/core';
import { navItems } from '../../_nav';
import { navItemsEpmaps } from '../../_nav';
import { navItemsAutofacturacion } from '../../_nav';
import { navItemsLuz } from '../../_nav';
import { navItemsGas } from '../../_nav';
import { Router } from '@angular/router';

import { ConsultaService } from '../../services/consulta.service';
import { LmedidorInteligenteService } from '../../services/lmedidor-inteligente.service';
import { numberToString } from '@amcharts/amcharts4/.internal/core/utils/Utils';
@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html',
  styleUrls: ['./default-layout.component.css']
})
export class DefaultLayoutComponent {
  public TransaccionesPendientes=0;
  public sidebarMinimized = false;
  public navItems = navItems;
  public navItemsEpmaps = navItemsEpmaps;
  public navItemsLuz = navItemsLuz;
  public navItemsGas = navItemsGas;
  public navItemsAutofacturacion = navItemsAutofacturacion;
  public tipoUser:any;
  
  constructor(private loading:ConsultaService, private consuta: LmedidorInteligenteService,private ruta:Router){
    this.tipoUser =localStorage.getItem("tipo");

}
cargando=0;
taman=0;
arrayalertas: any = [];
alertasICod: any;
medidor: any ={
  "Medidor": "AGUA"
}
detallemedidor:any= {
  "Tipo": "DMR",
  "Anio": 2021,
  "Mes": 7,
  "Medidor": "LUZ",
  "numMedidor": "22"
}
datosMedidor:any;

ngOnInit(): void {
this.capturar();
}
async capturar() {

   //this.medidoresI = await this.ngOnInit();
   this.arrayalertas = [];

       this.consuta.EjecutarServicioPost('/api/alertas',this.medidor).subscribe(
         result => {
           //this.loading.closeSweet();
           this.cargando=0;
           this.alertasICod = result;
          // console.log(this.alertasICod);
           this.taman= this.alertasICod.length;
           if(this.alertasICod.length==null)
            this.taman=0;
           /*for (var i = 0; i < this.alertasICod.length; i++) {
             this.alertasICod[i].ME_DEVICE_EUI=this.base64ToBase16(this.alertasICod[i].ME_DEVICE_EUI);
             this.alertasICod[i].ME_FREQUENCY=this.alertasICod[i].ME_FREQUENCY/1000000 + ' MHz';
             this.arrayalertas.push(this.alertasICod[i]);
           }*/
          
           //this.dtTrigger['uno'].next();

         },
         error => console.log(error));


 }
  toggleMinimize(e) {
    console.log(e);
    this.sidebarMinimized = e;

  }
  update(datos){
    
    let respues;
    let idMedidor =
    {
     "id":1
      
    }
    idMedidor.id=datos.AL_ID;
    let rutaParametros;
    this.detallemedidor.numMedidor =datos.AL_MEDIDOR;
    this.consuta.EjecutarServicioPost('/api/recepcion',this.detallemedidor).subscribe(
      result => {
        //this.loading.closeSweet();
        this.cargando=0;
        this.datosMedidor = result;
        console.log(this.datosMedidor);
        if(this.datosMedidor)
        {
          for (var i = 0; i < this.datosMedidor.length; i++) {
               localStorage.setItem("Cuenta", this.datosMedidor[i].MD_CUENTA);
               localStorage.setItem("medidor", this.datosMedidor[i].MD_ID);
               localStorage.setItem("serie", this.datosMedidor[i].MD_TIPO);
               localStorage.setItem("marca", this.datosMedidor[i].MD_MARCA);
               //this.ruta.navigate(["/medidores/detalle"]);
             //  this.ruta.onSameUrlNavigation = "reload";
             rutaParametros="/medidores/detalle/"+
             this.datosMedidor[i].MD_ID+"/"+
             this.datosMedidor[i].MD_CUENTA+"/"+
             this.datosMedidor[i].MD_TIPO+"/"+
             this.datosMedidor[i].MD_MARCA;
               this.ruta.navigate([rutaParametros]);
          }
        }
      },
      error => console.log(error));
    this.consuta.EjecutarServicioPost('/api/updalertas',idMedidor).subscribe(
      result => {
        //this.loading.closeSweet();
        this.cargando=0;
        respues = result;
        if(respues){
         this.capturar();
         this.ruta.navigate["detalle"]
        }
      },  error => console.log(error));
  }

  salir()
  {
    localStorage.clear();
    location.href="";

  }
}
